<template>
  <a-spin :spinning="loading">
    <div class="success">
      <div class="success_content" v-if="data.length > 0">
        <div class="item" :class="index % 3 != 0 ? 'space' : ''" v-for="(item, index) in data" :key="index">
          <div class="item_img">
            <img :src="item.conver" />
          </div>
          <p :title="item.matchName">{{ item.matchName }}</p>
        </div>
        <div style="text-align: right;width: 100%;" v-if="total > pageSize">
          <a-pagination :default-current="pageNo" v-model="pageNo" :total="total" :pageSize="pageSize" style="margin: 10px 0px;" @change="page()"/>
        </div>
      </div>
      <div class="empty" v-else>
        <img src="../../../assets/db_logo.png"/>
        <p>{{$t('案例准备中')}}...</p>
      </div>
    </div>
  </a-spin>
</template>
<script>
export default {
  data () {
    return {
      pageNo: 1,
      pageSize: 9,
      loading: false,
      data: [],
      total: 0
    }
  },
  mounted () {
    this.page()
  },
  methods: {
    page () {
      this.loading = true
      this.$api.projectCenter.pageSuccess(this.pageNo, this.pageSize, this.$route.query.programId).then(res => {
        if (res.status === 0) {
          this.data = res.data
          this.total = res.total
        } else {
          this.$message.error(res.msg)
        }
      }).catch(err => {
        this.$message.error(err)
      }).finally(_ => {
        this.loading = false
      })
    }
  }
}
</script>
<style scoped lang="scss">
  .success {
    background: #eaeaea;
    .success_content {
      padding-top: 40px;
      padding-bottom: 40px;
      width: 1200px;
      margin: auto;
      display: flex;
      flex-wrap: wrap;
      .item {
        width: 380px;
        overflow: hidden;
        .item_img {
          width: 100%;
          height: 210px;
          overflow: hidden;
          img {
            width: 100%;
            transform: scale(1);
            transition: .5s;
          }
          img:hover {
            transform: scale(1.1);
            transition: .5s;
          }
        }

        p {
          text-align: center;
          font-weight: 600;
          margin-top: 8px;
          overflow: hidden;
          text-overflow:ellipsis;
          white-space: nowrap;
          cursor: default;
        }
      }
      .space {
        margin-left: 30px;
      }
    }
    .empty {
      padding-top: 60px;
      padding-bottom: 60px;
      width: 1200px;
      margin: auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      img {
        height: 147px;
        width: 147px;
      }
      p {
        font-weight: 600;
        color: #838080;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/daoba-match/views/product/components/CenterSuccess.vue